/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Expiredtitle1Inputs */

const zh_learn_expiredtitle1 = /** @type {(inputs: Learn_Expiredtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该分享链接已过期`)
};

const en_learn_expiredtitle1 = /** @type {(inputs: Learn_Expiredtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This share link has expired`)
};

const es_learn_expiredtitle1 = /** @type {(inputs: Learn_Expiredtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este enlace de uso compartido ha expirado`)
};

/**
* | output |
* | --- |
* | "This share link has expired" |
*
* @param {Learn_Expiredtitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_expiredtitle1 = /** @type {((inputs?: Learn_Expiredtitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Expiredtitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_expiredtitle1(inputs)
	if (locale === "en") return en_learn_expiredtitle1(inputs)
	return es_learn_expiredtitle1(inputs)
});
export { learn_expiredtitle1 as "learn_expiredTitle" }